/**************************************************
 * Nombre:       Colecciones_Lista
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Tarjeta_Colecciones from "../../Tarjetas/Tarjeta_Colecciones";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";

const Colecciones_Lista = ({items = []}) => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: sCell ? 3 : 6, mt: -6}}
            >


                {items.map((it, index) => {
                    return (
                        <Grid container size={12} sx={{mt: 8}}>
                            <Tarjeta_Colecciones item={it}/>
                        </Grid>
                    )
                })}


            </Grid>

        </Grid>
    )

}
export default Colecciones_Lista
